import { isServer } from '@eos/b4b-shared-utility/is-server';
import { serializeError } from '@eos/shared-logger-utility/serializeError';
import { LogEntry } from '@eos/shared-logger-utility/types';

interface CreateLogEntryParams {
  error: unknown;
  message: string;
  getActivityId: () => string;
}

export const createLogEntry = ({
  error,
  message,
  getActivityId,
}: CreateLogEntryParams): LogEntry => ({
  level: 'error',
  message: `${isServer() ? 'Server side' : 'Client side'}: ${message}`,
  // Never log the raw error: an AxiosError carries the outbound request
  // config, whose headers hold the session Cookie and the IAM access token.
  errorInfo: serializeError(error),
  activityId: getActivityId(),
});
